module.exports = __webpack_public_path__ + "static/media/icon_123.1936d1e7.svg";